import React from 'react';
import './KPICard.css';

interface HeroProps {
  variant: 'hero';
  label: string;
  value: string;
  comparison?: {
    deltaPct: number;
    trend: 'up' | 'down' | 'flat';
    caption: string;
  } | null;
}

interface QuickProps {
  variant: 'quick';
  label: string;
  value: string;
  caption?: string;
}

type Props = HeroProps | QuickProps;

export function KPICard(props: Props) {
  if (props.variant === 'hero') {
    const arrow = props.comparison ? (props.comparison.trend === 'up' ? '↑' : props.comparison.trend === 'down' ? '↓' : '→') : null;
    return (
      <div className="kpi-hero">
        <span className="kpi-hero-label">{props.label}</span>
        <span className="kpi-hero-value">{props.value}</span>
        {props.comparison && (
          <div className={`kpi-hero-compare kpi-trend-${props.comparison.trend}`}>
            <span className="kpi-hero-arrow">{arrow}</span>
            <span className="kpi-hero-delta">{props.comparison.deltaPct >= 0 ? '+' : ''}{props.comparison.deltaPct.toFixed(0)}%</span>
            <span className="kpi-hero-caption">{props.comparison.caption}</span>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="kpi-quick">
      <span className="kpi-quick-value">{props.value}</span>
      <span className="kpi-quick-label">{props.label}</span>
      {props.caption && <span className="kpi-quick-caption">{props.caption}</span>}
    </div>
  );
}
